import styled from 'styled-components';

export default styled.div`

  padding: 2rem;
  background: rgba(111, 88, 255, 1);
  color: #ffffff;
  width: fit-content;
  border-radius: 1rem;
  cursor: pointer;

  ${props => props.thisStyling}

  &:hover {
    border: 1px solid #ffffff;
  }
`;
